import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackingDetailsStore, TransportDataService } from '@myarvato/modules/transport/services';
import { toObservable } from '@angular/core/rxjs-interop';
import { mergeMap, Observable, of } from 'rxjs';
import { Message } from 'primeng/message';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { catchError } from 'rxjs/operators';
import { DetailsComponent } from '../../components/details/details.component';

@Component({
  selector: 'transport-tracking-details-dialog',
  imports: [CommonModule, Message, TranslatePipe, DetailsComponent],
  templateUrl: './tracking-details-dialog.component.html',
  styleUrl: './tracking-details-dialog.component.scss',
})
export class TrackingDetailsDialogComponent {
  // dependency injection
  private readonly dataService = inject(TransportDataService);
  private readonly detailsStore = inject(TrackingDetailsStore);
  private readonly translateService = inject(TranslateService);

  // signals
  private readonly selectedItem$ = toObservable(this.detailsStore.selectedTrackingItem);
  protected readonly details$: Observable<DetailViewDto | undefined> = this.selectedItem$.pipe(
    mergeMap((item) => this.dataService.getDetailsById(item?.ehGuid)),
    catchError(() => {
      this.errorMessage.set(this.translateService.instant('pages.transport.detail-page.error-loading'));
      return of(undefined);
    }),
  );
  protected readonly errorMessage = signal<string>('');
}
